var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscountBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 20,
    viewBox: "0 0 39 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29687 0.986681C5.6561 0.375395 6.31213 0 7.02116 0H36.863C38.0432 0 39 1.11929 39 2.5V17.5C39 18.8807 38.0432 20 36.863 20H7.02116C6.31213 20 5.6561 19.6246 5.29687 19.0133L1.191 12.0266C0.455779 10.7756 0.455777 9.22444 1.191 7.97337L5.29687 0.986681Z",
    fill: "url(#paint0_linear_1825_4395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1825_4395",
    x1: 6.41096,
    y1: -0.0000024448,
    x2: 39.987,
    y2: 15.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48BBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB7B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountBadge);
export default __webpack_public_path__ + "static/media/discount-badge.a895e2beb484f7e33b04658b3e77d72c.svg";
export { ForwardRef as ReactComponent };